import React from 'react'
import PropTypes from 'prop-types'
import { MobileFilterContext } from '../../components'
import { QUERY_BLACKLIST as BLACKLIST } from '../../constants'

const MobileFilterButton = ({ query, filterKey, children }) => {
  const queryKeys = Object.keys(query)
  const keyFilter = key => BLACKLIST.includes(key) === false
  const filteredKeys = queryKeys.filter(keyFilter)
  const active = filteredKeys.length > 0

  return (
    <MobileFilterContext.Consumer>
      {({ setActivePanel }) => (
        <div className="rounded rounded-r-full py-2 px-4" onClick={() => setActivePanel(filterKey)}>
          <div className={`${active ? 'text-primary' : 'text-gray-999'} text-xs font-bold flex items-center`}>
            { children }
          </div>
        </div>
      )}
    </MobileFilterContext.Consumer>
  )
}

MobileFilterButton.propTypes = {
  filterKey: PropTypes.string.isRequired,
}

export { MobileFilterButton }
